export const NO_ASSIGNED_ROLES_CODE = 'NO_ASSIGNED_ROLES';
export function createNoAssignedRolesError() {
    return Object.assign(new Error('No role assigned to this account'), {
        code: NO_ASSIGNED_ROLES_CODE,
    });
}
export function isNoAssignedRolesError(error) {
    const code = error?.code;
    return code === NO_ASSIGNED_ROLES_CODE;
}
